// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteAccountView_container__6dmhO","sub":"DeleteAccountView_sub__dc7NB","deleteButton":"DeleteAccountView_deleteButton___CLma"};